import { StyleSheet } from 'react-native';
import { BLUE_500, tokens, typographyConfig, PRIMARY_BOLD_FONT, fitContentWidth } from '@airtel/air-design-system';
export var getLoanOfferWidgetStyles = props => {
  var fontConfig = typographyConfig[props === null || props === void 0 ? void 0 : props.theme];
  return StyleSheet.create({
    container: {
      alignItems: 'center'
    },
    imageUrl: {
      marginTop: tokens.spacing.SPACING_8,
      borderRadius: 16
    },
    heading: {
      marginTop: tokens.spacing.SPACING_16,
      textAlign: 'center'
    },
    subHeading: {
      marginTop: tokens.spacing.SPACING_4,
      textAlign: 'center'
    },
    title: {
      marginTop: tokens.spacing.SPACING_16,
      textAlign: 'center'
    },
    amountStyle: Object.assign(Object.assign({}, fontConfig.config.types['h3-bold'].typographyStyles), {
      fontFamily: PRIMARY_BOLD_FONT,
      textAlign: 'center'
    }),
    dividerStyle: {
      marginTop: tokens.spacing.SPACING_12
    },
    subTitle: {
      marginTop: tokens.spacing.SPACING_12,
      textAlign: 'center'
    },
    badgeStyle: Object.assign(Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 0,
      justifyContent: 'center',
      alignItems: 'center'
    }, fitContentWidth()), {
      borderWidth: 1,
      borderColor: BLUE_500,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_32,
      marginTop: tokens.spacing.SPACING_8
    }),
    infoTagStyle: {
      marginTop: tokens.spacing.SPACING_9
    },
    sliderStyle: {
      marginTop: tokens.spacing.SPACING_9,
      width: '100%'
    },
    calloutStyle: {
      marginTop: tokens.spacing.SPACING_16
    },
    tableDividerStyle: {
      marginTop: tokens.spacing.SPACING_16
    },
    tableStyle: {
      marginTop: tokens.spacing.SPACING_10
    }
  });
};